const { VITE_REACT_APP_SHA: REACT_APP_SHA } = import.meta.env

const REACT_APP_SHA_LENGTH = 8

const getVersion = (): string =>
  REACT_APP_SHA ? '-' + REACT_APP_SHA.substring(0, REACT_APP_SHA_LENGTH) : ''

export { getVersion }
